import React from "react";
import { TrendingUp } from "lucide-react";

export default function KpiCard({ title, value, hint, accent = "orange", testid }) {
  const colors = {
    orange: "from-orange-50 to-white",
    green: "from-emerald-50 to-white",
    blue: "from-blue-50 to-white",
    violet: "from-violet-50 to-white",
  };
  return (
    <div
      data-testid={testid}
      className={`h-full bg-gradient-to-br ${colors[accent]} border border-slate-200 rounded-xl p-5 shadow-sm`}
    >
      <div className="flex items-center justify-between">
        <div className="text-xs font-medium uppercase tracking-wider text-slate-500">{title}</div>
        <TrendingUp size={14} className="text-slate-400" />
      </div>
      <div className="text-3xl font-bold text-slate-900 mt-3 tracking-tight">{value}</div>
      {hint && <div className="text-xs text-slate-500 mt-2">{hint}</div>}
    </div>
  );
}
